import { Typography, Stack, Button, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function AboutJaaSection() {
  const { t } = useTranslation();

  return (
    <Stack
      sx={{
        position: 'relative',
        minHeight: { xs: '350px' },
        alignItems: 'center',
      }}
    >
      <Stack
        sx={{
          backgroundImage: `url("/ja_background.png")`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom center',
          height: { xs: '305px', sm: '375px', lg: '450px' },
          position: 'absolute',
          top: 0,
          right: 0,
          left: 0,
          zIndex: -1,
        }}
      />
      <Paper
        elevation={4}
        sx={{
          marginTop: { xs: 6, sm: 22.75, md: 23.75 },
          marginX: { xs: 3, sm: 6, md: 8 },
          maxWidth: '600px',
        }}
      >
        <Stack
          direction='column'
          sx={{
            paddingY: { xs: 2, md: 3 },
            paddingX: { xs: 3, md: 8 },
          }}
        >
          <Typography
            variant='h2'
            sx={{
              paddingY: 1,
            }}
          >
            {t('aboutJAA.title')}
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              paddingY: 1,
            }}
          >
            {t('aboutJAA.description')}
          </Typography>
          <Button
            variant='text'
            fullWidth
            size='medium'
            // Do not change the ID! It is used for Google Analytics tracking click event tracking.
            id='JA_click_marketing_page_link'
            href='https://www.almainsights.fi/kaikki-tuotteet-ja-palvelut/juridiikan-ajankohtaiset/'
            sx={{ textDecoration: 'none', textTransform: 'none' }}
          >
            {t('aboutJAA.readMore')}
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
}
